import { FC, useEffect, useState } from 'react';
import { Box, LinearProgress, Divider, useTheme } from '@mui/material';
import WidgetService from '../../services/WidgetService';
import GaugeComponent from 'react-gauge-component';

interface IWidgetGauge {
  growthPercentage: number;
  reviewScore: number;
}

const WidgetGauge: FC = () => {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<IWidgetGauge | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    const getReviewScore = async () => {
      try {
        const response = await WidgetService.reviewScore(setLoading, controller.signal);
        if (response) {
          setData(response);
          setLoading(false);
        } else {
          return;
        }
      } catch (error) {
        console.error('Error fetching review score:', error);
      }
    };

    getReviewScore();

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <Box>
      {loading ? (
        <Box>
          <LinearProgress sx={{ mt: theme.spacing(1), mb: theme.spacing(2) }} />
        </Box>
      ) : (
        <>
          <Divider sx={{ mt: theme.spacing(2), mb: theme.spacing(1) }} />
          <GaugeComponent
            type="radial"
            style={{ maxWidth: '350px', margin: '0 auto' }}
            labels={{
              valueLabel: {
                matchColorWithArc: true,
                formatTextValue: (v: string | number) => {
                  return v + '';
                },
                style: {
                  fontSize: '35px',
                  textShadow: 'none',
                },
              },
              tickLabels: {
                type: 'inner',
                ticks: [
                  { value: 0 },
                  { value: 17 },
                  { value: 33 },
                  { value: 50 },
                  { value: 67 },
                  { value: 83 },
                  { value: 100 },
                ],
              },
            }}
            arc={{
              colorArray: ['#ea676d', '#ee7c57', '#f39f32', '#f6b31a', '#9db136', '#4eaf50'],
              padding: 0.02,
              subArcs: [
                { limit: 17 },
                { limit: 33 },
                { limit: 50 },
                { limit: 67 },
                { limit: 83 },
                {},
              ],
            }}
            minValue={0}
            maxValue={100}
            pointer={{
              color: '#000',
              length: 0.8,
              width: 15,
              elastic: true,
            }}
            value={data?.reviewScore || 0}
          />
        </>
      )}
    </Box>
  );
};

export default WidgetGauge;
